export enum CustomGradeCode {
  Color = 'color-1',
  ColorViBox2 = 'color-2',
  ColorViBox3 = 'color-3',
  DeadZone = 'deadzones',
  BlueDispersion1 = 'fcrf-blue-dispersion-1',
  BlueUndertone1 = 'fcrf-blue-undertone-1',
  BlueFancyInner1 = 'fcrf-blue-fancy-inner-1',
  BlueFancyLightInner1 = 'fcrf-blue-fancy-light-inner-1',
  BlueIntenseInner1 = 'fcrf-blue-intense-inner-1',
  BlueVividInner1 = 'fcrf-blue-vivid-inner-1',
  PinkDispersion1 = 'fcrf-pink-dispersion-1',
  PinkUndertone1 = 'fcrf-pink-undertone-1',
  PinkFancyInner1 = 'fcrf-pink-fancy-inner-1',
  PinkFancyLightInner1 = 'fcrf-pink-fancy-light-inner-1',
  PinkIntenseInner1 = 'fcrf-pink-intense-inner-1',
  PinkVividInner1 = 'fcrf-pink-vivid-inner-1',
  YellowFancyDispersion1 = 'fcrf-yellow-dispersion-1',
  YellowUndertone1 = 'fcrf-yellow-undertone-1',
  YellowFancyInner1 = 'fcrf-yellow-fancy-inner-1',
  YellowFancyLightInner1 = 'fcrf-yellow-fancy-light-inner-1',
  YellowIntenseInner1 = 'fcrf-yellow-intense-inner-1',
  YellowVividInner1 = 'fcrf-yellow-vivid-inner-1',
}
